export default "__VITE_PUBLIC_ASSET__3c5fe96e__"